import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { EventsService } from '../services/events.service';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { Router } from '@angular/router';
import { CategoriesService } from '../services/categories.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { EncrDecrService } from '../services/encr-decr.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { MapsAPILoader } from '@agm/core';

 
@Component({
  selector: 'app-editevent',
  templateUrl: './editevent.component.html',
  styleUrls: ['./editevent.component.scss']
})
export class EditeventComponent implements OnInit {

  @ViewChild('picker') picker: any;
  clockTheme: NgxMaterialTimepickerTheme = {
    container: {
        bodyBackgroundColor: '#fff',
        buttonColor: '#5d2041',
    },
    dial: {
        dialBackgroundColor: '#5d2041',
    },
    clockFace: {
        clockFaceBackgroundColor: '#5d2041',
        clockHandColor: '#77BB00',
        clockFaceTimeInactiveColor: '#fff'
    }
};

  quillConfig={
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['clean'],                                         // remove formatting button
        ['link'],
      ],
    },
    keyboard: {
      bindings: {
        enter:{
          key:13,
          handler: (range, context)=>{
            console.log("enter");
            return true;
          }
        }
      }
    }
  }

  eventFee:boolean;
  minFee:any;
  maxFee:any;
  formattedaddress=" "; 
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: Date;
  public maxDate: Date;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  public disableMinute = false;
  public hideTime = false;
  step;
  time = {hour: 0, minute: 0};
  public dateControl = new FormControl(null);

  public options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ];

  public listColors = ['primary', 'accent', 'warn'];

  public stepHours = [1, 2, 3, 4, 5];
  public stepMinutes = [1, 5, 10, 15, 20, 25];

  public categories = [];


  public coOrganizers: any[] = [{
    email: '',
  }];

  public uploader: FileUploader = new FileUploader({});

  eventForm: FormGroup;
  rangeDate: FormGroup;

  constructor(private formBuilder: FormBuilder,
    private eventService: EventsService,
    private EncDecService: EncrDecrService,
    private router: Router,
    private categoriesService: CategoriesService,
    private _snackBar: MatSnackBar,
    private toastr: ToastrService, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone) { }


    @ViewChild("placesRef") placesRef : GooglePlaceDirective;

    public placesOptions = {
      componentRestrictions: { country: 'LB' },
      // types: ['geocode']
      };
    
    public handleAddressChange(address: Address) {
      this.eventForm.get('location').setValue(address.formatted_address);
  }

  eventDetails: any;

  recurring: boolean
  date
  eventLength

  EventId

  eventImage

  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  private geoCoder;
  @ViewChild('search') searchElementRef: ElementRef;
  locationLng:any;
  locationLat:any;
  // address: string;
  // private geoCoder;
  
  ngOnInit() {
    this.eventDetails = JSON.parse(localStorage.getItem("editevent"))
      console.log(this.eventDetails)


      this.eventDetails.location_lat= this.latitude
      this.eventDetails.location_lng= this.longitude

      const startingTime = this.eventDetails.event_dates[0].start_time.slice(0,5)
      const endingTime = this.eventDetails.event_dates[0].end_time.slice(0,5)
      this.eventLength = this.eventDetails.event_dates.length - 1
      this.rangeDate = this.formBuilder.group({
        start: "",
        end: ""
      });
      if(this.eventDetails.is_recurring == 1) {
       this.recurring = true 
    
        this.rangeDate = this.formBuilder.group({
          start: this.eventDetails.event_dates[0].date,
          end: this.eventDetails.event_dates[this.eventLength].date
        });
       
      } else if(this.eventDetails.is_recurring == 0){ 
      this.recurring = false
      this.date = this.eventDetails.event_dates[0].date
      
      }
      this.EventId = this.eventDetails.id
   
    this.eventForm = this.formBuilder.group({
      EventName: this.eventDetails.event_name,
      organizerName: this.eventDetails.organizer_name,
      description: this.eventDetails.description,
      isRecurring: this.recurring,
      date: this.date,
      range_date: this.rangeDate,
      start_time: startingTime,
      end_time: endingTime,
      location: this.eventDetails.location,
      website: this.eventDetails.website,
      img: this.eventDetails.images[0].filename
    });
    const file = (this.eventDetails.images[0].filename as HTMLInputElement);
    this.eventForm.patchValue({
      img: file
    });

    this.eventForm.get('img').updateValueAndValidity();
    this.minFee = this.eventDetails.min_fee
    this.maxFee = this.eventDetails.max_fee
    if(this.minFee == 0 && this.maxFee == 0){
      this.eventFee = true
    } else {this.eventFee = false}
    

    this.categoriesService.getAllCategories().then((res: any) => {
      for (let i = 0; i < res.categories.length; i++) {
        this.categories.push({
          id: res.categories[i].id,
          name: res.categories[i].name,
          selected: this.isSelected(res.categories[i].id)
        })
      }
    })
      .catch((error) => {
      })
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = 1;
        this.longitude = 1;
        this.zoom = 24;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }
  markerDragEnd($event: any) {
    console.log(JSON.parse(JSON.stringify($event.latLng)).lat);
    this.latitude = JSON.parse(JSON.stringify($event.latLng)).lat;
    this.longitude = JSON.parse(JSON.stringify($event.latLng)).lng;
    this.locationLat = this.latitude
    this.locationLng = this.longitude
    console.log('lat:' + this.latitude)
    this.getAddress(this.latitude, this.longitude);
  }
  searchEnd(){
    setTimeout(() => {
      this.confirmlocation()
    }, 1000);
  }
  confirmlocation(){
    this.locationLat = this.latitude
    this.locationLng = this.longitude  }

  findAdress(){
    this.mapsAPILoader.load().then(() => {
         let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement,this.placesOptions);
         autocomplete.addListener("place_changed", () => {
           this.ngZone.run(() => {
             // some details
             let place: google.maps.places.PlaceResult = autocomplete.getPlace();
             this.address = place.formatted_address;
             this.eventForm.get('location').setValue(this.address);
             //set latitude, longitude and zoom
             this.latitude = place.geometry.location.lat();
             this.longitude = place.geometry.location.lng();
             this.zoom = 12;
           });
         });
       });
   }
  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
    });
  }
  ngAfterViewInit(){
    this.findAdress()
  }

  onChange(event){
    this.recurring = !this.recurring
  }

  changeSelected($event, category): void {
    category.selected = $event.selected;
  }

  addAddress() {
    this.coOrganizers.push({
      email: '',
    });
  }

  // getFiles(): FileLikeObject[] {
  //   return this.uploader.queue.map((fileItem) => {
  //     return fileItem.file;
  //   });
  // }

  url;
  msg = "";

  selectFile(event) {

    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.msg = "";
      this.url = reader.result;
    }

    const file = (event.target as HTMLInputElement).files[0];
    this.eventForm.patchValue({
      img: file
    });

    this.eventForm.get('img').updateValueAndValidity();
  }

  isSelected(id) {
    let x: any[] = this.eventDetails.category_list
    let ids: any[] = []
    x.forEach((res) => {ids.push(res.category_id)})    
    if (ids.includes(id)) return true;
    return false
  }
  updateEvent() {
    let selectedCategories:number[] = [];
    for(let i=0; i<this.categories.length;i++){
      if(this.categories[i].selected)
        selectedCategories.push(this.categories[i].id)
    }
    var formData: FormData = new FormData();
    formData.append("event_name", this.eventForm.get('EventName').value);
    formData.append("organizer_name", this.eventForm.get('organizerName').value);
    formData.append("organizer_email", this.eventDetails.organizer_email);
    formData.append("category", selectedCategories+'');
    formData.append("min_fee", this.minFee);
    formData.append("max_fee", this.maxFee);
    formData.append("website", this.eventForm.get('website').value);
    formData.append("description", this.eventForm.get('description').value);
    formData.append("location", this.eventForm.get('location').value);
    formData.append("location_lat", this.eventForm.get('locationLat').value);
    formData.append("location_lng", this.eventForm.get('locationLng').value);
    formData.append("is_recurring", this.eventForm.get('isRecurring').value == '' || this.eventForm.get('isRecurring').value == false ? '0' : '1');
    formData.append("country", this.eventDetails.country);
    if(this.eventForm.get('isRecurring').value == '' || this.eventForm.get('isRecurring').value == false || this.eventForm.get('isRecurring').value == undefined)
    {
  
      const startDate = new Date(this.eventForm.value.date);
      const startTime = this.eventForm.get('start_time').value;
      const endTime = this.eventForm.get('end_time').value;
      formData.append("event_dates[]", JSON.stringify({ "date": startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate(), "start_time": startTime, "end_time": endTime }));
    }
    else{
      const startDate = new Date(this.rangeDate.value.start);
      const endDate = new Date(this.rangeDate.value.end);
      const startTime = this.eventForm.get('start_time').value;
      const endTime = this.eventForm.get('end_time').value;
     
      formData.append("recurring_dates[]", JSON.stringify({ "from_date": startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate(), "to_date": endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate(), "start_time": startTime, "end_time": endTime }));
    }
    
    formData.append("images[]", this.eventForm.get('img').value);
    this.eventService.updateEvent(this.EventId, formData).then((res: any) => {
      if (res.success) {
            this.url = "";
            this.msg = "";
            this.toastr.success(
              'Your modifications have been successfully submitted, our team will review your submission and you will be notified accordingly',
              'Event Submitted', {
              timeOut: 6000,
              progressBar: true,
              closeButton: true
            });
          }
          else {
            this._snackBar.open(res.error, '', {
              duration: 5000,
              panelClass: ['error-snackbar'],
              verticalPosition: 'top',
    
            });
          }
        })
          .catch((error) => {
            console.log(error)
      });


  }

  freeEventChange()
  {
    if(this.minFee != 0 && this.maxFee != 0)
    {
      this.minFee = 0;
      this.maxFee = 0;

    }
else{
  this.minFee = 1;
  this.maxFee = 1;

}

  }

}